<template>
  <el-dialog title="修改目的地" width="700px" close-on-click-modal :visible.sync="dialogVisible" @close="dialogClose">
    <el-form :model="form" label-width="130px" label-position="right" :rules="rules" ref="ruleForm" class="settlement-form">
      <el-form-item label="运单号：" style="margin-top: 15px">
        <el-input v-model="form.waybillNo" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="交车港：" style="margin-top: 15px">
        <el-select filterable v-model="form.arrivePortId" size="mini" style="width: 100%" placeholder="请选择" value-key="id">
          <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="交车区域：" style="margin-top: 15px">
        <el-cascader size="mini" style="width: 100%" v-model="form.arrivePlaceId" placeholder="请选择" :options="areaOption" :props="{ value: 'id', label: 'cityName', children: 'children' }" clearable filterable />
      </el-form-item>
      <el-form-item>
        <div class="flex-center-center mt10">
          <el-button size="mini" class="searchBtn" :loading="submitLoading" @click="submit"> 修改 </el-button>
          <el-button size="mini" class="resetBtn" @click="dialogClose">关闭</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { batchUpdateDestination, supplierPublicSelectPort } from '@/service/vehiclelog';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    name: 'ArrivePlace',
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        defaultForm: {},
        form: {
          carIdList: [],
          arrivePortId: '',
          arrivePlaceId: '',
          waybillNo: '',
        },
        rules: {
          waybillNo: [
            {
              required: true,
              message: '请填写运单号',
              trigger: 'blur',
            },
          ],
          arrivePortId: [
            {
              required: true,
              message: '请选择目的地',
              trigger: 'blur',
            },
          ],
          arrivePlaceId: [
            {
              required: true,
              message: '请选择交车区域',
              trigger: 'blur',
            },
          ],
        },
        portOption: [],
        areaOption: [],
      };
    },
    mounted() {
      this.areaOption = JSON.parse(getSessionStore('areaList'));
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      this.getPort();
    },
    methods: {
      dialogOpen(carIdList) {
        this.dialogVisible = true;
        this.form.carIdList = carIdList;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      //港口名称
      async getPort() {
        let res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.portOption = res.data.map(item => {
          return {
            supplier_name: item.supplier_name,
            id: item.id,
          };
        });
      },
      submit() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (this.form.arrivePortId == '' && this.form.arrivePlaceId == '') return this.$message.warning('操作失败，港口和目的地必选一个！');
            if (this.form.arrivePlaceId) this.form.arrivePlaceId = this.form.arrivePlaceId[this.form.arrivePlaceId.length - 1];
            this.submitLoading = true;
            const { status, message } = await batchUpdateDestination(this.form);
            this.submitLoading = false;
            if (status !== 0) {
              this.$emit('empty');
              return this.$message.error(message);
            }
            this.$message.success(message);
            this.dialogClose();
            this.$emit('search');
            this.$emit('empty');
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
